import { Component, Inject, NgZone, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Data, ErrorType, Image, ImageTypeEnum } from "../../../dto";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpFacetecService } from "src/app/service/http-facetec.service";
import { catchError } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { DataService } from "src/app/service/data.service";
import { trackJourney } from "src/app/utils/utils";
import { RefService } from "src/app/service/ref.service";
import { TranslateService } from "@ngx-translate/core";
import { ConfigService } from "src/app/service/config.service";

@Component({
    selector: "app-submit",
    templateUrl: "./submit.component.html",
    styleUrls: ["./submit.component.scss"],
})
export class SubmitComponent {
    data: Data;

    direction;

    moreReviewRequired;

    constructor(
        private router: Router,
        private httpService: HttpFacetecService,
        private refService: RefService,
        private configService: ConfigService,
        private dataService: DataService,
        private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        @Inject(TranslateService) private translateService: TranslateService,
        private zone: NgZone,
    ) {
        trackJourney({
            ref: this.refService.getRef() as string,
            page: "submit_start",
            httpService: this.httpService,
        });
        this.data = this.dataService.getData() as Data;
        this.data.ref = this.refService.getRef() as string;
        
        const lang = this.configService.getLanguage() || 'en';
        this.translateService.use(lang);

        this.direction = this.translateService.currentLang === 'ar' ? 'rtl' : 'ltr';

        console.log("Direction", this.direction);
        console.log("Current Lang", this.translateService.currentLang);

        this.translateService.onLangChange.subscribe(event => {
            this.direction = event.lang === 'ar' ? 'rtl' : 'ltr';
        });

        const config = this.configService.getConfig();
        this.moreReviewRequired = (config && config.furtherReviewMsgEnabled) && (this.data.frontSpoofed || this.data.backSpoofed || this.data.isLikelyOnFraudList || this.data.unexpectedMediaEncountered);
    }

    getImage(ordinal: number) {
        this.data = this.dataService.getData() as Data;
        switch (ordinal) {
            case ImageTypeEnum.Portrait:
                return (
                    "data:image/jpeg;base64," +
                    this.data.imageList.filter((item) => item.type == ImageTypeEnum.Portrait)[0]
                        .image
                );
            case ImageTypeEnum.IdPhotoFace:
                return (
                    "data:image/jpeg;base64," +
                    this.data.imageList.filter((item) => item.type == ImageTypeEnum.IdPhotoFace)[0]
                        .image
                );
            case ImageTypeEnum.IdPhotoFront:
                return (
                    "data:image/jpeg;base64," +
                    this.data.imageList.filter((item) => item.type == ImageTypeEnum.IdPhotoFront)[0]
                        .image
                );
            case ImageTypeEnum.IdPhotoBack:
                return (
                    "data:image/jpeg;base64," +
                    this.data.imageList.filter((item) => item.type == ImageTypeEnum.IdPhotoBack)[0]
                        .image
                );
            case ImageTypeEnum.IdSignature:
                return (
                    "data:image/jpeg;base64," +
                    this.data.imageList.filter((item) => item.type == ImageTypeEnum.IdSignature)[0]
                        .image
                );
            case ImageTypeEnum.Signature:
                return this.data.imageList.filter((item) => item.type == ImageTypeEnum.Signature)[0]
                    .image;
            default:
                return null;
        }
    }

    getImageType(ordinal: number) {
        switch (ordinal) {
            case ImageTypeEnum.Portrait:
                return "Portrait";
            case ImageTypeEnum.IdPhotoFace:
                return "ID Face";
            case ImageTypeEnum.IdPhotoFront:
                return "ID Front";
            case ImageTypeEnum.IdPhotoBack:
                return "ID Back";
            case ImageTypeEnum.IdSignature:
                return "ID Signature";
            case ImageTypeEnum.Signature:
                return "Signature";
            default:
                return "Unknown";
        }
    }

    submit() {
        this.data = this.dataService.getData() as Data;
        var images = this.data.imageList.map((item) => {
            var imageData = item.image;
            if (item.type === ImageTypeEnum.Signature) {
                //Remove the base64 prefix crap
                imageData = (imageData as string).replace("data:image/png;base64,", "");
            }

            return {
                image: imageData,
                type: item.type,
            };
        });

        var data: Data = {
            sessionId: this.data.sessionId,
            firstName: this.data.firstName,
            lastName: this.data.lastName,
            fullName: this.data.fullName,
            nationality: this.data.nationality,
            nationalityNonMRZValue: this.data.nationalityNonMRZValue,
            countryCode: this.data.countryCode,
            countryCodeNonMRZValue: this.data.countryCodeNonMRZValue,
            dateOfBirth: this.data.dateOfBirth,
            placeOfBirth: this.data.placeOfBirth,
            idNumber: this.data.idNumber,
            idGroupName: this.data.idGroupName,
            idBarcode: this.data.idBarcode,
            dateOfIssue: this.data.dateOfIssue,
            dateOfExpiration: this.data.dateOfExpiration,
            sex: this.data.sex, //yes pleassexe
            address: this.data.address,
            imageList: images,
            userConfirmedValues: this.data.userConfirmedValues,
            barcodeTemplateName: this.data.barcodeTemplateName,
            barcodeTemplateType: this.data.barcodeTemplateType,
            ocrTemplateName: this.data.ocrTemplateName,
            ocrTemplateType: this.data.ocrTemplateType,
            idPhotoMatchLevel: this.data.idPhotoMatchLevel,
            ageEstimate: this.data.ageEstimate,
            browser: this.data.browser,
            deviceModel: this.data.deviceModel,
            deviceSDK: this.data.deviceSDK,
            ipAddress: this.data.ipAddress,
            platform: this.data.platform,
            idNumber2: this.data.idNumber2,
            idMatchScore: this.data.idMatchScore,
            idPartialMatch: this.data.idPartialMatch,
            isLikelyOnFraudList: this.data.isLikelyOnFraudList,
            frontSpoofed: this.data.frontSpoofed,
            backSpoofed: this.data.backSpoofed,
            unexpectedMediaEncountered: this.data.unexpectedMediaEncountered,
        };

        this.spinner.show();

        let errorType = null;

        if (this.data.frontSpoofed || this.data.backSpoofed) {
            errorType = ErrorType.IdSpoofDetected;
        }

        if (this.data.isLikelyOnFraudList) {
            errorType = ErrorType.FraudListMatch;
        }


        console.log("Submitting data with errorType:", {errorType, data: { ...data, imageList: [] }});

        if (errorType !== null) {
            this.httpService
                .processError(this.data.ref as string, {
                    data: data,
                    errorType: errorType,
                })
                .pipe(
                    catchError((error) => {
                        this.spinner.hide();
                        console.log("Error submitting process error data", error);
                        this.toastr.error((error.statusText ? error.statusText : error.message), 'Error');
                        throw error;
                    }),
                )
                .subscribe((result) => {
                    this.spinner.hide();
                    if (result.redirectUrl) {
                        this.zone.runOutsideAngular(() => {
                            setTimeout(function () {
                                document.location.href = result.redirectUrl;
                            }, 100);
                        });
                    } else {
                        this.configService.setTryAgain(true);
                        this.router.navigate(["/facetec"]);
                    }
                });
        } else {
            this.httpService
                .process(this.data.ref as string, data)
                .pipe(
                    catchError(async (error) => {
                        this.spinner.hide();
                        console.log("Error submitting data", error);
                        this.toastr.error(error.statusText ? error.statusText : error.message, await this.translateService.get("error").toPromise());
                        throw error;
                    }),
                )
                .subscribe(async (result) => {
                    this.spinner.hide();
                    if (!result) {
                        this.toastr.error(await this.translateService.get("failed_submit_data").toPromise(), await this.translateService.get("error").toPromise());
                        return;
                    }
                    if (result.status) {
                        trackJourney({
                            ref: this.refService.getRef() as string,
                            page: "submit_success",
                            httpService: this.httpService,
                        });
                        this.toastr.success(await this.translateService.get("sumitted_success").toPromise(), await this.translateService.get("success").toPromise());

                        if (result.redirectUrl) {
                            this.zone.runOutsideAngular(() => {
                                setTimeout(function () {
                                    document.location.href = result.redirectUrl;
                                }, 1000);
                            });
                        }

                        return;
                    }

                    this.toastr.error(await this.translateService.get("failed_submit_data").toPromise() + " " + result.error, await this.translateService.get("error").toPromise());
                });
        }
    }
}
